export { useSmartChoice } from './useSmartChoice';
